export default __webpack_public_path__ + "static/media/person.322b7603.svg";